import React from 'react';
import {imageProps, imageProps2, imageProps3, imageDescription} from './data';
import {Container, Image, Ul} from '../../../Components/Atom';
import * as S from './style';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {expiredIMG} from '../../../config/images';
import styled from 'styled-components';
import {viewSize, colorPalette} from '../../../config';
import {
	provide,
	provide2,
	provideTitle,
	provideTitle2,
	provideTitle3,
	provide3,
	provide4,
	provide5,
} from './data';
import {ContentTitle} from '../../../Components/Organism';
export const ExpiredImg = styled.img`
	width: 100%;
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
	}
`;

export const ExpiredText = styled.div`
	color: ${colorPalette.white};
	font-family: 'Gmarket';
	font-size: 35px;
	font-weight: 600;
	text-align: center;
	@media screen and (max-width: ${viewSize.mobile}) {
		font-size: 20px;
	}
`;

const Gift = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '기념품']} />
			<S.Container>
				{/* <ExpiredText>준비중입니다.</ExpiredText>
				<ExpiredImg src={expiredIMG} /> */}
				{/* <S.ImageWrapper>
					<Image {...imageProps} />
					<Image {...imageProps2} />
				</S.ImageWrapper>
				{/* <S.UlWrapper>
					<Ul {...imageDescription} />
				</S.UlWrapper> */}
				{/* <CardSection {...provide} /> */}
				<ContentTitle {...provideTitle.title} />
				<S.DescriptionText>
					10.19km 코스 참가자에게 제공되는 기념품입니다.
				</S.DescriptionText>
				<S.ImageWrapper>
					<Image {...imageProps} />
				</S.ImageWrapper>
				<ContentTitle {...provideTitle2.title} />
				<S.DescriptionText>
					5km 코스 참가자에게 제공되는 기념품입니다.
				</S.DescriptionText>
				<S.ImageWrapper>
					<Image {...imageProps2} />
				</S.ImageWrapper>
				<ContentTitle {...provideTitle3.title} />
				<S.DescriptionText>
					완주 후에 지급하는 기념품입니다.
				</S.DescriptionText>
				<S.ImageWrapper>
					<Image {...imageProps3} />
				</S.ImageWrapper>
			</S.Container>
		</Container>
	);
};

export default Gift;
